import { useState, useImperativeHandle, forwardRef, useRef, React, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

const SignUpIdInput = forwardRef((props, ref) => {
	const { className, placeholder, type, clickCountFn, clickFn, text, isClicked, setIsClicked } = props;
	const { t } = useLanguage();
	const { isDark } = useTheme();
	const theme = isDark ? darkTheme : lightTheme;
	const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [message, setMessage] = useState(text);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const BorderRef = useRef();
	const inputRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		setDefaultPlaceholder: (val) => {
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = theme.pointRed;
			BorderRef.current.style.borderColor = theme.pointRed;
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = theme.line;
			BorderRef.current.style.borderColor = theme.line;
		}
	}));

	useEffect(() => {
		setDefaultPlaceholder(placeholder);
	}, [placeholder])

	useEffect(() => {
		clickCountFn(className, clickCount);
	}, [clickCount, value])

	function handleClick(e) {
		inputRef.current.style.borderColor = theme.primary;
		BorderRef.current.style.borderColor = theme.primary;
		setDefaultPlaceholder('');
	}

	function handleChange(e) {
		setValue(e.target.value);
		setChanged(true);
		setIsClicked(false);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = theme.line;
	}

	return (
		<TopLevelWrapper ref={BorderRef}>
			<Input
				ref={inputRef}
				clickCount={clickCount}
				type={type}
				placeholder={defaultPlaceholder}
				value={value}
				className={`${className} ${changed ? "changed" : ""}`}
				onClick={handleClick}
				onChange={handleChange}
				onFocus={handleFocus}
				onBlur={handleBlur} />
				<CheckButton onClick={clickFn} isClicked={isClicked}>
					{ isClicked ? t('signUp.checkComplete') : t('signUp.duplicateCheck')}
				</CheckButton>
		</TopLevelWrapper>
	)
});

export default SignUpIdInput;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: space-between;
	align-items: flex-end;
	
	// border-width: 0 0 1px 0;
	border-bottom: 1px solid ${props => props.theme.line};

  transition: all 0.5s ease-in-out;
	// border-color: #E8E8E8;

	
	// border-width: 0 0 1px 0;
	// border-color: #E8E8E8;
	// border: 0px;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 16px;
	// font-size: max(12px, 0.7291666666666667vw);
	// line-height: 20px;
	
	padding: 0 0 4px 0;
	margin-top: 10px;
	// margin-top: max(12px, 0.8333333333333333vw);

	// width: 80%;
	width: calc(100% - 79px);

	outline: none;
	// border-width: 0 0 1px 0;
	// border-color: #E8E8E8;
	border: 0px;
	color: ${props => props.theme.text};
	background-color: transparent;

	::placeholder {
		color: ${props => props.clickCount < 1 || props.value !== '' ? props.theme.subText : props.theme.pointRed};
	}
	
  transition: all 0.5s ease-in-out;
`;

const CheckButton = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: center;
	align-items: center;

	width: 79px;
	height: 32px;

	border-radius: 8px 8px 0 0;
	background-color: ${props => props.isClicked ? props.theme.line : props.theme.primary};

	font-family: NotoSansKR-Bold;
	font-size: max(14px, 0.625vw);

	color: ${props => props.theme.subBackground};

	margin-bottom: -1px;

  transition: all 0.5s ease-in-out;

	@media (hover: hover) {
		&:hover {
			cursor: pointer;
		}
	}
`;